var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6465 16.5538L9.00006 16.9074L9.35361 16.5538L19.2536 6.65381L19.2536 6.65381L19.2557 6.65166C19.3008 6.60609 19.3544 6.56991 19.4135 6.54522C19.4726 6.52053 19.536 6.50781 19.6001 6.50781C19.6641 6.50781 19.7275 6.52053 19.7866 6.54522C19.8457 6.56991 19.8993 6.60609 19.9444 6.65165L19.9443 6.65168L19.9487 6.65594C19.9942 6.70096 20.0304 6.75458 20.0551 6.81368C20.0798 6.87278 20.0925 6.9362 20.0925 7.00025C20.0925 7.06431 20.0798 7.12772 20.0551 7.18683C20.0304 7.24593 19.9942 7.29954 19.9486 7.34455L19.9467 7.34653L9.34667 17.9365L9.3465 17.9367C9.15177 18.1314 8.83835 18.1314 8.64361 17.9367L4.45361 13.7467L4.45362 13.7467L4.45146 13.7446C4.40589 13.6995 4.36972 13.6459 4.34502 13.5868C4.32033 13.5277 4.30762 13.4643 4.30762 13.4003C4.30762 13.3362 4.32033 13.2728 4.34502 13.2137C4.36971 13.1546 4.40589 13.101 4.45146 13.0559L4.45148 13.056L4.45575 13.0517C4.50076 13.0061 4.55438 12.9699 4.61348 12.9452C4.67259 12.9205 4.736 12.9078 4.80006 12.9078C4.86411 12.9078 4.92753 12.9205 4.98663 12.9452C5.04573 12.9699 5.09935 13.0061 5.14437 13.0517L5.14436 13.0517L5.1465 13.0538L8.6465 16.5538Z",
    fill: "#323232",
    stroke: "#306A57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7032ab185e5fcb86334960c53c4ef998.svg";
export { ForwardRef as ReactComponent };